import { FC } from 'react';
import { Link } from 'react-router-dom';
import jzLogo from '../../images/jz-logo30.png';
import styles from './index.module.scss';

const Header: FC = () => {
	return (
		<header className={styles.Header}>
			<ul>
				<li>
					<img width="30px" src={jzLogo} alt="jz logo" />
				</li>
				<li style={{ marginLeft: 'auto' }}>
					<Link to="/privacy-policy">Privacy Policy</Link>
				</li>
				<li>
					<Link to="/terms-of-service">Terms of Service</Link>
				</li>
				<li>
					<Link to="/terms-and-conditions">Terms and Conditions</Link>
				</li>
			</ul>
		</header>
	);
};

export default Header;
